<script setup>
import { computed, onMounted } from 'vue';
import { useWebStore } from '@/store/web.js';
import NavBarItem from "@/components/NavBarItem.vue";
import HamburgerMenu from "@/components/Hamburger-menu.vue";
import LanguageChooser from "@/components/LanguageChooser.vue";
import NavBarDropdown from "@/components/NavBarDropdown.vue";




// Define props using defineProps
const props = defineProps({
  height: String
});

// Store setup
const store = useWebStore();


const sites = computed(() => {
  return store.sites.filter((site) => site.show !== false);
});

// A hamburger menüben nincs bal/jobb blokk, ezért a `right` elemek (jogi
// oldalak) magától a tömb sorrendjétől a tevékenységi körök KÖZÉ kerülnének.
// Desktopon a szűrés miatt hátul vannak — itt ugyanezt a sorrendet állítjuk elő.
const hamburgerItems = computed(() => [
  ...store.sites.filter((site) => !site.right),
  ...store.sites.filter((site) => site.right),
]);

// CSS properties passed as style props
const CSSProps = computed(() => ({
  '--height': props.height
}));
</script>
<template>
  <div class="navBar deep-shadow" :style="CSSProps">
    <img
        class="h-3/5 ml-4 mr-6 sm:mr-10 lg:mr-6"
        src="/poliol_logo.webp"
        @click="store.navigateToPage(store.sites[0].url)"
        alt="POLIOL Logo"
    />

    <!-- DESKTOP NAV -->

      <!-- A betűméret-lépcsők mérésből származnak: a leghosszabb nyelv a román
           (955px text-sm-nél), ezért 1536px alatt text-xs, 1700px felett tér
           vissza az eredeti text-lg. Így mind a 4 nyelv egy sorban marad. -->
      <div style="width: 100%; height: 100%;" class="hidden xl:flex flex-wrap text-gray-800 gap-4 text-xs min-[1600px]:text-sm min-[1900px]:text-lg">

      <!-- BALOLDALI LINKJEK -->
      <template v-for="site in sites.filter(page => !page.right)" :key="site.url">
        <nav-bar-dropdown v-if="site.children?.length" :site="site" />
        <NuxtLink
            v-else
            :to="'/' + store.chosenLang + '/' + site.url"
            class="unstyled-link nav-link"
        >
          <nav-bar-item
              :id="'nav_' + site.url"
              :text="site.text"
              :link="site.url"
          />
        </NuxtLink>
      </template>

      <!-- JOBB OLDALI (JOGI) LINKJEK — mindig egy fokozattal kisebb betűvel,
           mint a fő menüsor, különben a négy tevékenységi körrel együtt nem
           férnek el egy sorban. -->
      <div class="ml-auto hidden min-[1440px]:flex flex-wrap gap-3 text-gray-600 text-[11px] min-[1600px]:text-xs min-[1900px]:text-sm">
        <NuxtLink
            v-for="site in sites.filter(page => page.right)"
            :key="site.url"
            :to="'/' + store.chosenLang + '/' + site.url"
            class="unstyled-link nav-link"
        >
          <nav-bar-item
              :id="'nav_' + site.url"
              :text="site.text"
              :link="site.url"
          />
        </NuxtLink>
      </div>
    </div>

    <!-- HAMBURGER MENÜ MOBILRA -->
    <hamburger-menu
        class="bigMac xl:hidden"
        :items="hamburgerItems"
    />

    <!-- NYELVVÁLASZTÓ -->
    <LanguageChooser
        v-if="store.screenSize !== 'mobile'"
        class="mr-2 sm:mr-4 md:mr-6 lg:mr-6 hidden sm:flex ml-3"
    />
  </div>
</template>


<style scoped lang="scss">
.navBar {
  transition: 0.6s ease;
  background-color: #f9f9f9;
  position: fixed;
  height: var(--height, 7dvh);
  width: 100vw;
  display: flex;
  align-items: center;
  z-index: 100;
  top: 0;
  left: 0;
  padding-right: 1rem;
}

.nav-link {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
</style>
